// extracted by mini-css-extract-plugin
module.exports = {"stars":"styles_stars__qlwUT","starIcon":"styles_starIcon__lYbGO"};